import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class DeleteNetlifyID extends PureComponent {
    
    constructor(props) {
        super(props);
    
        this.state = {
            confirmText: 'Delete',
            cancelText: 'Cancel',
            prompt: 'Are you sure you want to delete the build hook (netlify ID) for this item?',
          };
    }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Delete Build Hook (Netlify ID)?</ModalHeader>
        <ModalBody>{this.state.prompt}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.cancelText}
          </Button>
          <Button
            color="danger"
            onClick={this.props.onLinkNetlify}
            disabled={this.props.buttonsDisabled}
          >
            {this.state.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default DeleteNetlifyID;


// WEBPACK FOOTER //
// ./src/views/Components/DeleteNetlifyID.js